/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PostDistrictStudentsPlacementsContentAreaR200ResponseAnyOfWarningsInnerFromJSON, PostDistrictStudentsPlacementsContentAreaR200ResponseAnyOfWarningsInnerToJSON, } from './PostDistrictStudentsPlacementsContentAreaR200ResponseAnyOfWarningsInner';
import { PostDistrictStudentsPlacementsContentAreaReadingR200ResponseAnyOfPreviewInnerFromJSON, PostDistrictStudentsPlacementsContentAreaReadingR200ResponseAnyOfPreviewInnerToJSON, } from './PostDistrictStudentsPlacementsContentAreaReadingR200ResponseAnyOfPreviewInner';
/**
 * Check if a given object implements the PostDistrictStudentsPlacementsContentAreaReadingR200Response interface.
 */
export function instanceOfPostDistrictStudentsPlacementsContentAreaReadingR200Response(value) {
    if (!('preview' in value) || value['preview'] === undefined)
        return false;
    if (!('warnings' in value) || value['warnings'] === undefined)
        return false;
    return true;
}
export function PostDistrictStudentsPlacementsContentAreaReadingR200ResponseFromJSON(json) {
    return PostDistrictStudentsPlacementsContentAreaReadingR200ResponseFromJSONTyped(json, false);
}
export function PostDistrictStudentsPlacementsContentAreaReadingR200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return Object.assign(Object.assign({}, json), { 'preview': (json['preview'].map(PostDistrictStudentsPlacementsContentAreaReadingR200ResponseAnyOfPreviewInnerFromJSON)), 'warnings': (json['warnings'].map(PostDistrictStudentsPlacementsContentAreaR200ResponseAnyOfWarningsInnerFromJSON)) });
}
export function PostDistrictStudentsPlacementsContentAreaReadingR200ResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return Object.assign(Object.assign({}, value), { 'preview': (value['preview'].map(PostDistrictStudentsPlacementsContentAreaReadingR200ResponseAnyOfPreviewInnerToJSON)), 'warnings': (value['warnings'].map(PostDistrictStudentsPlacementsContentAreaR200ResponseAnyOfWarningsInnerToJSON)) });
}
